var map = {
	"./about/about.module": [
		"./src/app/about/about.module.ts",
		"about-about-module"
	],
	"./hydrant/hydrant.module": [
		"./src/app/hydrant/hydrant.module.ts",
		"hydrant-hydrant-module"
	],
	"./sandsack/sandsack.module": [
		"./src/app/sandsack/sandsack.module.ts",
		"sandsack-sandsack-module"
	],
	"./schaummittel/schaummittel.module": [
		"./src/app/schaummittel/schaummittel.module.ts",
		"schaummittel-schaummittel-module"
	],
	"./schlauch/schlauch.module": [
		"./src/app/schlauch/schlauch.module.ts",
		"schlauch-schlauch-module"
	],
	"./seilwinde/seilwinde.module": [
		"./src/app/seilwinde/seilwinde.module.ts",
		"seilwinde-seilwinde-module"
	],
	"./tankpendel/tankpendel.module": [
		"./src/app/tankpendel/tankpendel.module.ts",
		"tankpendel-tankpendel-module"
	],
	"./tauchpumpe/tauchpumpe.module": [
		"./src/app/tauchpumpe/tauchpumpe.module.ts",
		"tauchpumpe-tauchpumpe-module"
	],
	"./termsuse/termsuse.module": [
		"./src/app/termsuse/termsuse.module.ts",
		"termsuse-termsuse-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;